import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import InitiativeSheet from "../components/InitiativeSheet";
import { trackInitiative } from "../lib/initiativeTrack";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Landing pubblica di una singola iniziativa: /scopri/iniziativa/:slug (condivisibile via WhatsApp / QR)
export default function InitiativePage() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  const src = new URLSearchParams(window.location.search).get("src") || "direct";
  useEffect(() => { axios.get(`${API}/public/initiatives/${slug}`).then((r) => { setD(r.data); trackInitiative(r.data.slug, "visit", src); }).catch(() => setErr(true)); }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <main className="min-h-screen bg-zinc-100 py-6 px-3" data-testid="initiative-page">
      <div className="mx-auto max-w-xl space-y-4">
        <Link to="/scopri" className="text-sm text-zinc-700 hover:underline" data-testid="initiative-back">← Torna alla pagina del circuito</Link>
        {err && <div className="rounded-2xl bg-white p-6 text-center text-zinc-700" data-testid="initiative-not-found">Iniziativa non disponibile.</div>}
        {!err && !d && <div className="rounded-3xl bg-white shadow-lg overflow-hidden animate-pulse" data-testid="initiative-loading"><div className="h-[260px] bg-zinc-300" /><div className="h-12 bg-zinc-200" /><div className="p-5 space-y-3"><div className="h-4 w-2/3 rounded bg-zinc-200" /><div className="h-4 w-1/2 rounded bg-zinc-200" /><div className="h-4 w-3/4 rounded bg-zinc-200" /></div></div>}
        <InitiativeSheet d={d} onCta={() => { trackInitiative(d?.slug, "cta", src); window.location.href = "/cliente"; }} />
      </div>
    </main>
  );
}
